import React from "react";
import styles from "./styles.module.scss";
import { UIText } from "src/components/uIKit";
import classNames from "classnames";
import { IDS } from "src/utils/enums";
interface ErrorMessageProps {
  message?: string;
  style?: string;
  id?: IDS;
  ariaLabel?: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, style, id, ariaLabel }) => {
  if (!message) {
    return null;
  }

  return (
    <div className={classNames(styles.error, style)} role="alert" aria-live="polite" aria-atomic="true" id={id}>
      <UIText 
        {...(ariaLabel ? { ariaLabel } : {})}
        text={message} 
        size={14} 
        weight={500} 
      />
    </div>
  );
};

export default ErrorMessage;
